/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EvaluationCommentIncludeFilterItems } from './evaluationCommentIncludeFilterItems';
import { EvaluationCommentScopeFilter } from './evaluationCommentScopeFilter';


export interface EvaluationCommentIncludeFilterInner { 
    relation?: EvaluationCommentIncludeFilterInner.RelationEnum;
    scope?: EvaluationCommentScopeFilter;
}
export namespace EvaluationCommentIncludeFilterInner {
    export type RelationEnum = 'evaluation';
    export const RelationEnum = {
        Evaluation: 'evaluation' as RelationEnum
    };
}


